// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { Action } from "redux"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { create } from "@bufbuild/protobuf"
import { t } from "@lingui/macro"
import * as TimelineActions from "../actions"
import * as TimelineSlice from "../slices/timeline"
import { showSnackBar } from "../../snackbar/actions"
import { executorMutation, Init, timelineService } from "../../../app/rpc"
import { EmptyTrashRequestSchema, EmptyTrashResponse } from "../../../generated/wisetime/user/timeline/v4/timeline_pb"

type EmptyTrashRpc = (request: Init<typeof EmptyTrashRequestSchema>) => Observable<EmptyTrashResponse>

export const emptyTrash = (emptyTrashRpc: EmptyTrashRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(TimelineActions.emptyTrash.match),
      mergeMap(action => emptyTrashRpc(action.payload.request).pipe(
        map(_ => {
          action.payload.onComplete()
          return TimelineSlice.removeAllTrashedTimeRows()
        }),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_empty_trash_failed",
            message: "Failed to empty trash. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
          }),
          messageType: "ERROR",
        })))),
      )
    )

const emptyTrashRpc = (request: Init<typeof EmptyTrashRequestSchema>): Observable<EmptyTrashResponse> =>
  executorMutation(() => timelineService.emptyTrash(create(EmptyTrashRequestSchema, request)))

export default emptyTrash(emptyTrashRpc)
